<form [formGroup]="formGroup">
  <mat-grid-list cols="4" rowHeight="75px">
    <!--ICD Category-->
    <mat-grid-tile>
      <mat-form-field>
        <mat-label>ICD Category</mat-label>
        <input [formControlName]="controls.IcdCategory" type="text" matInput readonly>
      </mat-form-field>
    </mat-grid-tile>
  </mat-grid-list>
</form>

<!------------------------------------------------>
<!--4 Primary/Secondary Diagnosis/Procedure column -->
<!------------------------------------------------>

<mat-grid-list cols="4">
  <form [formGroup]="formGroup">

    <!---------------------------->
    <!-- Radio Buttons-->
    <!---------------------------->

    <mat-grid-list cols="4" rowHeight="75px">
      <mat-grid-tile>
        <label>Update Primary Diagnosis</label>
        <mat-radio-group [formControlName]="controls.PrimaryDiagnosisOptions" class="m-l-5"
												 [name]="radioGroupName.PrimaryDiagnosisRadioGroup"
												 (change)="onUpdateRadioOption($event)">
          <mat-radio-button class="m-r-5" [value]="statusType.Yes">Yes</mat-radio-button>
          <mat-radio-button class="m-r-5" [value]="statusType.No">No</mat-radio-button>
        </mat-radio-group>

      </mat-grid-tile>
      <mat-grid-tile>
        <label>Update Secondary Diagnosis</label>
        <mat-radio-group [formControlName]="controls.SecondaryDiagnosisOptions" class="m-l-5"
												 [name]="radioGroupName.SecondaryDiagnosisRadioGroup"
												 (change)="onUpdateRadioOption($event)">
          <mat-radio-button class="m-r-5" [value]="statusType.Yes">Yes</mat-radio-button>
          <mat-radio-button class="m-r-5" [value]="statusType.No">No</mat-radio-button>
        </mat-radio-group>

      </mat-grid-tile>

      <ng-container [ngSwitch]=processingClassSubtype>
        <ng-container *ngSwitchCase="processingClassSubTypeEnum.Hospital">
          <ng-container *ngTemplateOutlet="hospitalSubType;"></ng-container>
        </ng-container>
      </ng-container>

      <ng-template #hospitalSubType>
        <mat-grid-tile>
          <label>Update Primary Procedure</label>
          <mat-radio-group [formControlName]="controls.PrimaryProcedureOptions" class="m-l-5"
                           [name]="radioGroupName.PrimaryProcedureRadioGroup"
                           (change)="onUpdateRadioOption($event)">
            <mat-radio-button class="m-r-5" [value]="statusType.Yes">Yes</mat-radio-button>
            <mat-radio-button class="m-r-5" [value]="statusType.No">No</mat-radio-button>
          </mat-radio-group>

        </mat-grid-tile>
        <mat-grid-tile>
          <label>Update Secondary Procedure</label>
          <mat-radio-group [formControlName]="controls.SecondaryProcedureOptions" class="m-l-5"
                           [name]="radioGroupName.SecondaryProcedureRadioGroup"
                           (change)="onUpdateRadioOption($event)">
            <mat-radio-button class="m-r-5" [value]="statusType.Yes">Yes</mat-radio-button>
            <mat-radio-button class="m-r-5" [value]="statusType.No">No</mat-radio-button>
          </mat-radio-group>

        </mat-grid-tile>
      </ng-template>

    </mat-grid-list>


    <ng-container *ngIf="isRadioOptionEnabled()">
      <!---------------------------->
      <!-- Row-1-->
      <!---------------------------->

      <mat-grid-list cols="4" rowHeight="75px">

        <!-- Column-1-->
				<!--Empty Spacer Primary Diagnosis-->
        <mat-grid-tile>&nbsp;</mat-grid-tile>


        <!-- Column-2-->
				<!--Empty Spacer Secondary Diagnosis-->
				<mat-grid-tile>&nbsp;</mat-grid-tile>

        <!-- Column-3-->
        <mat-grid-tile *ngIf="formGroup.get(controls.PrimaryProcedureOptions).value  === statusType.Yes">
          <mat-form-field class="w-80">
            <mat-label>Procedure Schema</mat-label>
            <mat-select [formControlName]="controls.PrimaryProcedureSchema">
              <mat-option *ngFor="let procedureSchema of procedureSchemaLookUpValues" [value]="procedureSchema.value"
                          (onSelectionChange)="onProcedureSchemasLookUpValueSelected(diagnosisOrProcedureType.PrimaryProcedure)">
                {{procedureSchema.name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
					<mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Procedure Schema')">help_outline</mat-icon>
				</mat-grid-tile>


				<!---------------------------->
				<!-- Empty Spacer 4th column -->
				<!---------------------------->

				<ng-container *ngFor="let emptySpacer of [1]">
					<mat-grid-tile *ngIf="formGroup.get(controls.PrimaryProcedureOptions).value  === statusType.No">
					</mat-grid-tile>
				</ng-container>

				<!---------------------------->
				<!-- ./Empty Spacer-->
				<!---------------------------->

        <!-- Column-4-->
        <mat-grid-tile *ngIf="formGroup.get(controls.SecondaryProcedureOptions).value  === statusType.Yes">
          <mat-form-field class="w-80">
            <mat-label>Procedure Schema</mat-label>
            <mat-select [formControlName]="controls.SecondaryProcedureSchema">
              <mat-option *ngFor="let procedureSchema of procedureSchemaLookUpValues" [value]="procedureSchema.value"
                          (onSelectionChange)="onProcedureSchemasLookUpValueSelected(diagnosisOrProcedureType.SecondaryProcedure)">
                {{procedureSchema.name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
					<mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Procedure Schema')">help_outline</mat-icon>
				</mat-grid-tile>

      </mat-grid-list>


      <!---------------------------->
      <!-- Row-2-->
      <!---------------------------->

      <mat-grid-list cols="4" rowHeight="75px">

        <!-- Column-1 Primary: Diagnosis Description-->
        <mat-grid-tile *ngIf="formGroup.get(controls.PrimaryDiagnosisOptions).value  === statusType.Yes">
          <mat-form-field class="w-80">
            <mat-label>Diagnosis Description</mat-label>
            <input type="text" matInput
                   [formControlName]="controls.PrimaryDiagnosisDescription"
                   (input)="diagnosisPrimaryDescriptionTextChanged$.next($any($event.target).value)"
                   (blur)="onBlur(diagnosisOrProcedureType.PrimaryDiagnosis)"
                   [matAutocomplete]="primaryDiagnosisAuto">
            <mat-autocomplete #primaryDiagnosisAuto="matAutocomplete"
															[panelWidth]="'40vw'">
              <mat-option *ngFor="let diagnosis of filteredDiagnosis"
                          [value]="getDiagnosisDisplayString(diagnosis)"
                          (onSelectionChange)="onDiagnosisSelected(diagnosis, diagnosisOrProcedureType.PrimaryDiagnosis)">
                {{getDiagnosisDisplayString(diagnosis)}}
              </mat-option>
            </mat-autocomplete>
					</mat-form-field>
					<mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Diagnosis Description')">help_outline</mat-icon>
        </mat-grid-tile>

        <!---------------------------->
        <!-- Empty Spacer 2nd column -->
        <!---------------------------->

        <ng-container *ngFor="let emptySpacer of [1]">
          <mat-grid-tile *ngIf="formGroup.get(controls.PrimaryDiagnosisOptions).value  === statusType.No">
          </mat-grid-tile>
        </ng-container>

        <!---------------------------->
        <!-- ./Empty Spacer-->
        <!---------------------------->

        <!-- Column-2 Secondary: Diagnosis Description-->
        <mat-grid-tile *ngIf="formGroup.get(controls.SecondaryDiagnosisOptions).value  === statusType.Yes">
          <mat-form-field class="w-80">
            <mat-label>Diagnosis Description</mat-label>
            <input type="text" matInput
                   [formControlName]="controls.SecondaryDiagnosisDescription"
                   (input)="diagnosisSecondaryDescriptionTextChanged$.next($any($event.target).value)"
                   (blur)="onBlur(diagnosisOrProcedureType.SecondaryDiagnosis)"
                   [matAutocomplete]="secondaryDiagnosisAuto">
            <mat-autocomplete #secondaryDiagnosisAuto="matAutocomplete"
															[panelWidth]="'40vw'">
              <mat-option *ngFor="let diagnosis of filteredDiagnosis"
                          [value]="getDiagnosisDisplayString(diagnosis)"
                          (onSelectionChange)="onDiagnosisSelected(diagnosis, diagnosisOrProcedureType.SecondaryDiagnosis)">
                {{getDiagnosisDisplayString(diagnosis)}}
              </mat-option>
            </mat-autocomplete>
					</mat-form-field>
					<mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Diagnosis Description')">help_outline</mat-icon>
				</mat-grid-tile>

        <!---------------------------->
        <!-- Empty Spacer 3rd column -->
        <!---------------------------->

        <ng-container *ngFor="let emptySpacer of [1]">
          <mat-grid-tile *ngIf="formGroup.get(controls.SecondaryDiagnosisOptions).value  === statusType.No">
          </mat-grid-tile>
        </ng-container>

        <!---------------------------->
        <!-- ./Empty Spacer-->
        <!---------------------------->

        <!-- Column-3 Primary: Procedure Description-->
        <mat-grid-tile *ngIf="formGroup.get(controls.PrimaryProcedureOptions).value  === statusType.Yes">
          <mat-form-field class="w-80">
            <mat-label>Procedure Description</mat-label>
            <input type="text" matInput
                   [formControlName]="controls.PrimaryProcedureDescription"
                   (input)="procedureDescriptionTextChangedPrimary$.next($any($event.target).value)"
                   (blur)="onBlur(diagnosisOrProcedureType.PrimaryProcedure)"
                   [matAutocomplete]="primaryProcedureDescriptionAuto">
            <mat-autocomplete #primaryProcedureDescriptionAuto="matAutocomplete"
															[panelWidth]="'40vw'">
              <mat-option *ngFor="let codingSchema of filteredCodingSchema"
                          [value]="getCodingSchemaDisplayString(codingSchema)"
                          (onSelectionChange)="onProcedureDescriptionSelected(codingSchema, diagnosisOrProcedureType.PrimaryProcedure)">
                {{getCodingSchemaDisplayString(codingSchema)}}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
					<mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Procedure Description')">help_outline</mat-icon>
				</mat-grid-tile>

				<!---------------------------->
				<!-- Empty Spacer 4th column -->
				<!---------------------------->

				<ng-container *ngFor="let emptySpacer of [1]">
					<mat-grid-tile *ngIf="formGroup.get(controls.PrimaryProcedureOptions).value  === statusType.No">
					</mat-grid-tile>
				</ng-container>

				<!---------------------------->
				<!-- ./Empty Spacer-->
				<!---------------------------->

        <!-- Column-4: Secondary:Procedure Description -->
        <mat-grid-tile *ngIf="formGroup.get(controls.SecondaryProcedureOptions).value  === statusType.Yes">
          <mat-form-field class="w-80">
            <mat-label>Procedure Description</mat-label>
            <input type="text" matInput
                   [formControlName]="controls.SecondaryProcedureDescription"
                   (input)="procedureDescriptionTextChangedSecondary$.next($any($event.target).value)"
                   (blur)="onBlur(diagnosisOrProcedureType.SecondaryProcedure)"
                   [matAutocomplete]="secondaryProcedureDescriptionAuto">
            <mat-autocomplete #secondaryProcedureDescriptionAuto="matAutocomplete"
															[panelWidth]="'40vw'">
              <mat-option *ngFor="let codingSchema of filteredCodingSchema"
                          [value]="getCodingSchemaDisplayString(codingSchema)"
                          (onSelectionChange)="onProcedureDescriptionSelected(codingSchema, diagnosisOrProcedureType.SecondaryProcedure)">
                {{getCodingSchemaDisplayString(codingSchema)}}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
					<mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Procedure Description')">help_outline</mat-icon>
        </mat-grid-tile>
      </mat-grid-list>


      <!---------------------------->
      <!-- Row-3 Start Date-->
      <!---------------------------->

      <mat-grid-list cols="4" rowHeight="75px">

        <!-- Column-1-->
        <mat-grid-tile *ngIf="formGroup.get(controls.PrimaryDiagnosisOptions).value  === statusType.Yes">
          <mat-form-field class="w-80">
            <mat-label>Start Date</mat-label>
            <input [formControlName]="controls.PrimaryDiagnosisStartDate"
                   [matDatepicker]="primaryDiagnosisStartDatePicker" matInput
                   [min]="formGroup.controls[controls.PrimaryDiagnosisMinStartDate].value">
            <mat-datepicker-toggle [for]="primaryDiagnosisStartDatePicker" matIconSuffix>
            </mat-datepicker-toggle>
            <mat-datepicker #primaryDiagnosisStartDatePicker></mat-datepicker>
          </mat-form-field>
					<mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Diagnosis Start Date')">help_outline</mat-icon>
				</mat-grid-tile>

        <!---------------------------->
        <!-- Empty Spacer 2nd column -->
        <!---------------------------->

        <ng-container *ngFor="let emptySpacer of [1]">
          <mat-grid-tile *ngIf="formGroup.get(controls.PrimaryDiagnosisOptions).value  === statusType.No">
          </mat-grid-tile>
        </ng-container>

        <!---------------------------->
        <!-- ./Empty Spacer-->
        <!---------------------------->

        <!-- Column-2-->
        <mat-grid-tile *ngIf="formGroup.get(controls.SecondaryDiagnosisOptions).value  === statusType.Yes">
          <mat-form-field class="w-80">
            <mat-label>Start Date</mat-label>
            <input [formControlName]="controls.SecondaryDiagnosisStartDate"
                   [matDatepicker]="secondaryDiagnosisStartDatePicker" matInput
                   [min]="formGroup.controls[controls.SecondaryDiagnosisMinStartDate].value">
            <mat-datepicker-toggle [for]="secondaryDiagnosisStartDatePicker" matIconSuffix>
            </mat-datepicker-toggle>
            <mat-datepicker #secondaryDiagnosisStartDatePicker></mat-datepicker>
          </mat-form-field>
					<mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Diagnosis Start Date')">help_outline</mat-icon>
        </mat-grid-tile>


        <!---------------------------->
        <!-- Empty Spacer 3rd column -->
        <!---------------------------->

        <ng-container *ngFor="let emptySpacer of [1]">
          <mat-grid-tile *ngIf="formGroup.get(controls.SecondaryDiagnosisOptions).value  === statusType.No">
          </mat-grid-tile>
        </ng-container>

        <!---------------------------->
        <!-- ./Empty Spacer-->
        <!---------------------------->

        <!-- Column-3-->
        <mat-grid-tile *ngIf="formGroup.get(controls.PrimaryProcedureOptions).value  === statusType.Yes">
          <mat-form-field class="w-80">
            <mat-label>Start Date</mat-label>
            <input [formControlName]="controls.PrimaryProcedureStartDate"
                   [matDatepicker]="primaryProcedureStartDatePicker" matInput
                   [min]="formGroup.controls[controls.PrimaryProcedureMinStartDate].value">
            <mat-datepicker-toggle [for]="primaryProcedureStartDatePicker" matIconSuffix>
            </mat-datepicker-toggle>
            <mat-datepicker #primaryProcedureStartDatePicker></mat-datepicker>
          </mat-form-field>
					<mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Procedure Start Date')">help_outline</mat-icon>
				</mat-grid-tile>

				<!---------------------------->
				<!-- Empty Spacer 4th column -->
				<!---------------------------->

				<ng-container *ngFor="let emptySpacer of [1]">
					<mat-grid-tile *ngIf="formGroup.get(controls.PrimaryProcedureOptions).value  === statusType.No">
					</mat-grid-tile>
				</ng-container>

				<!---------------------------->
				<!-- ./Empty Spacer-->
				<!---------------------------->


				<!-- Column-4-->
        <mat-grid-tile *ngIf="formGroup.get(controls.SecondaryProcedureOptions).value  === statusType.Yes">
          <mat-form-field class="w-80">
            <mat-label>Start Date</mat-label>
            <input [formControlName]="controls.SecondaryProcedureStartDate"
                   [matDatepicker]="secondaryProcedureStartDatePicker" matInput
                   [min]="formGroup.controls[controls.SecondaryProcedureMinStartDate].value">
            <mat-datepicker-toggle [for]="secondaryProcedureStartDatePicker" matIconSuffix>
            </mat-datepicker-toggle>
            <mat-datepicker #secondaryProcedureStartDatePicker></mat-datepicker>
          </mat-form-field>
					<mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Procedure Start Date')">help_outline</mat-icon>
        </mat-grid-tile>
      </mat-grid-list>


      <!---------------------------->
      <!-- Row-4 Buttons-->
      <!---------------------------->
      <mat-grid-list cols="4" rowHeight="75px">

        <!-- Column-1-->
        <mat-grid-tile *ngIf="formGroup.get(controls.PrimaryDiagnosisOptions).value  === statusType.Yes">
          <button class="w-50" mat-raised-button color="primary"
                  (click)="onUpdateDiagnosisPrimaryHistory()">
            Update Diagnosis
          </button>
        </mat-grid-tile>


        <!---------------------------->
        <!-- Empty Spacer 2nd column -->
        <!---------------------------->

        <ng-container *ngFor="let emptySpacer of [1]">
          <mat-grid-tile *ngIf="formGroup.get(controls.PrimaryDiagnosisOptions).value  === statusType.No">
          </mat-grid-tile>
        </ng-container>

        <!---------------------------->
        <!-- ./Empty Spacer-->
        <!---------------------------->

        <!-- Column-2-->
        <mat-grid-tile *ngIf="formGroup.get(controls.SecondaryDiagnosisOptions).value  === statusType.Yes">
          <button class="w-50" mat-raised-button color="primary"
                  (click)="onUpdateDiagnosisSecondaryHistory()">
            Update Diagnosis
          </button>
        </mat-grid-tile>


        <!---------------------------->
        <!-- Empty Spacer 3rd column -->
        <!---------------------------->

        <ng-container *ngFor="let emptySpacer of [1]">
          <mat-grid-tile *ngIf="formGroup.get(controls.SecondaryDiagnosisOptions).value  === statusType.No">
          </mat-grid-tile>
        </ng-container>

        <!---------------------------->
        <!-- ./Empty Spacer-->
        <!---------------------------->

        <!-- Column-3-->
        <mat-grid-tile *ngIf="formGroup.get(controls.PrimaryProcedureOptions).value  === statusType.Yes">
          <button class="w-50" mat-raised-button color="primary"
                  (click)="onUpdateProcedurePrimaryHistory()">
            Update Procedure
          </button>
        </mat-grid-tile>


				<!---------------------------->
				<!-- Empty Spacer 4th column -->
				<!---------------------------->

				<ng-container *ngFor="let emptySpacer of [1]">
					<mat-grid-tile *ngIf="formGroup.get(controls.PrimaryProcedureOptions).value  === statusType.No">
					</mat-grid-tile>
				</ng-container>

				<!---------------------------->
				<!-- ./Empty Spacer-->
				<!---------------------------->

        <!-- Column-4-->
        <mat-grid-tile *ngIf="formGroup.get(controls.SecondaryProcedureOptions).value  === statusType.Yes">
          <button class="w-50" mat-raised-button color="primary"
                  (click)="onUpdateProcedureSecondaryHistory()">
            Update Procedure
          </button>
        </mat-grid-tile>

      </mat-grid-list>

    </ng-container>


    <!--------------------------------------->
    <!--History Section-->
    <!--------------------------------------->
    <mat-divider></mat-divider>

    <!-- Column-1: Primary Diagnosis History-->

    <div style="width: 25%; float: left;">
      <section class="history-column m-t-50 m-b-5">
        <div class="mat-primary-color text-center">
          <label>Primary Diagnosis History</label>
        </div>
        <div class="status-history-section" *ngFor="let diagnosisLinkDTO of caseHospitalDiagnosesLinkDTOPrimaryList">
          <div class="history-date-width" gdTooltip>
            {{
            diagnosisLinkDTO?.diagnosis?.code}} {{diagnosisLinkDTO?.diagnosis.description | truncateText: {
            sliceStart: 0,
            sliceEnd: 15,
            completeWords: true,
            append: '...'
          } }} : {{diagnosisLinkDTO.startDate | date: dateFormat}} - {{diagnosisLinkDTO.endDate  | date: dateFormat}}

						<ng-template #tooltipTemplate>
							<div class="tooltip">
								{{diagnosisLinkDTO?.diagnosis?.code}} {{diagnosisLinkDTO?.diagnosis.description}}
							</div>
						</ng-template>
          </div>
					<div class="trash-icon">
            <mat-icon class="mat-primary-color hand-cursor" matTooltip="DELETE"
                      (click)="onDeleteHistory(diagnosisLinkDTO, diagnosisOrProcedureType.PrimaryDiagnosis)">
              delete
            </mat-icon>
          </div>
        </div>
        <div *ngIf="caseHospitalDiagnosesLinkDTOPrimaryList && caseHospitalDiagnosesLinkDTOPrimaryList.length === 0">
          <p class="light-grey">Set the primary diagnosis using the controls above</p>
        </div>
      </section>
    </div>

    <!-- Column-2: Secondary Diagnosis History-->
    <div style="width: 25%; float: left;">
      <section class="history-column m-t-50 m-b-5">
        <div class="mat-primary-color text-center">
          <label>Secondary Diagnosis History</label>
        </div>
        <div class="status-history-section"
             *ngFor="let diagnosisLinkDTO of caseHospitalDiagnosesLinkDTOSecondaryList">

          <!--Note:-->
          <!--Display string must only show the start date. Ignore the end date.-->
          <div class="history-date-width" gdTooltip>
            {{
            diagnosisLinkDTO?.diagnosis?.code}} {{diagnosisLinkDTO?.diagnosis.description | truncateText: {
            sliceStart: 0,
            sliceEnd: 20,
            completeWords: true,
            append: '...'
          } }} : {{diagnosisLinkDTO.startDate | date: dateFormat}}

						<ng-template #tooltipTemplate>
							<div class="tooltip">
								{{diagnosisLinkDTO?.diagnosis?.code}} {{diagnosisLinkDTO?.diagnosis.description}}
							</div>
						</ng-template>
          </div>
          <div class="trash-icon">
            <mat-icon class="mat-primary-color hand-cursor" matTooltip="DELETE"
                      (click)="onDeleteHistory(diagnosisLinkDTO, diagnosisOrProcedureType.SecondaryDiagnosis)">
              delete
            </mat-icon>
          </div>
        </div>

        <div
          *ngIf="caseHospitalDiagnosesLinkDTOSecondaryList && caseHospitalDiagnosesLinkDTOSecondaryList.length === 0">
          <p class="light-grey">Set the secondary diagnosis using the controls above</p>
        </div>
      </section>
    </div>

    <ng-container [ngSwitch]=processingClassSubtype>
      <ng-container *ngSwitchCase="processingClassSubTypeEnum.Hospital">
        <ng-container *ngTemplateOutlet="hospitalSubTypeList;"></ng-container>
      </ng-container>
    </ng-container>

    <ng-template #hospitalSubTypeList>
      <!-- Column-3: Primary Procedure History-->
      <div style="width: 25%; float: left;">
        <section class="history-column m-t-50 m-b-5">
          <div class="mat-primary-color text-center">
            <label>Primary Procedure History</label>
          </div>
          <div class="status-history-section"
               *ngFor="let codingSchemaLinkDTO of caseHospitalCodingSchemaLinkDTOPrimaryList">
            <div class="history-date-width" gdTooltip>
              {{
              codingSchemaLinkDTO?.codingSchema?.code}} {{codingSchemaLinkDTO?.codingSchema?.shortDescription | truncateText: {
              sliceStart: 0,
              sliceEnd: 15,
              completeWords: true,
              append: '...'
            } }} : {{codingSchemaLinkDTO.startDate | date: dateFormat}}
              - {{codingSchemaLinkDTO.endDate  | date: dateFormat}}

              <ng-template #tooltipTemplate>
                <div class="tooltip">
                  {{codingSchemaLinkDTO?.codingSchema?.code}} {{codingSchemaLinkDTO?.codingSchema?.shortDescription}}
                </div>
              </ng-template>
            </div>
            <div class="trash-icon">
              <mat-icon class="mat-primary-color hand-cursor" matTooltip="DELETE"
                        (click)="onDeleteHistory(codingSchemaLinkDTO, diagnosisOrProcedureType.PrimaryProcedure)">
                delete
              </mat-icon>
            </div>
          </div>
          <div
            *ngIf="caseHospitalCodingSchemaLinkDTOPrimaryList && caseHospitalCodingSchemaLinkDTOPrimaryList.length === 0">
            <p class="light-grey">Set the primary procedure using the controls above</p>
          </div>
        </section>
      </div>

      <!-- Column-4: Secondary Procedure History-->
      <div style="width: 25%; float: left;">
        <section class="history-column m-t-50 m-b-5">
          <div class="mat-primary-color text-center">
            <label>Secondary Procedure History</label>
          </div>
          <div class="status-history-section"
               *ngFor="let codingSchemaLinkDTO of caseHospitalCodingSchemaLinkDTOSecondaryList">

            <!--Note:-->
            <!--Display string must only show the start date. Ignore the end date.-->
            <div class="history-date-width" gdTooltip>
              {{
              codingSchemaLinkDTO?.codingSchema?.code}} {{codingSchemaLinkDTO?.codingSchema?.shortDescription | truncateText: {
              sliceStart: 0,
              sliceEnd: 20,
              completeWords: true,
              append: '...'
            }
              }} : {{codingSchemaLinkDTO.startDate | date: dateFormat}}

              <ng-template #tooltipTemplate>
                <div class="tooltip">
                  {{codingSchemaLinkDTO?.codingSchema?.code}} {{codingSchemaLinkDTO?.codingSchema?.shortDescription}}
                </div>
              </ng-template>
            </div>
            <div class="trash-icon">
              <mat-icon class="mat-primary-color hand-cursor" matTooltip="DELETE"
                        (click)="onDeleteHistory(codingSchemaLinkDTO, diagnosisOrProcedureType.SecondaryProcedure)">
                delete
              </mat-icon>
            </div>
          </div>
          <div
            *ngIf="caseHospitalCodingSchemaLinkDTOSecondaryList && caseHospitalCodingSchemaLinkDTOSecondaryList.length === 0">
            <p class="light-grey">Set the secondary procedure using the controls above</p>
          </div>
        </section>
      </div>

    </ng-template>


    <!--------------------------------------->
    <!--Navigation Buttons-->
    <!--------------------------------------->
    <div class="button-container">
      <button mat-raised-button matStepperPrevious color="primary">Back</button>
      <button mat-raised-button color="warn" (click)="resetAdmissionFormGroup();">Clear</button>
      <button mat-raised-button matStepperNext color="primary"
              [disabled]="!formGroup.valid || !isDiagnosisPrimaryHistoryExist() || isRadioOptionEnabled()">
        Next
        <mat-icon *ngIf="!isDiagnosisPrimaryHistoryExist() || isRadioOptionEnabled()"

                  [matTooltip]="!isDiagnosisPrimaryHistoryExist()
                                ? 'Please select at least 1 primary diagnosis'
                                : isRadioOptionEnabled()
                                ? 'Please finish updating the diagnosis or procedure, otherwise ensure all selections are set to No'
                                : null"
                  class="info-icon">
          help_outline
        </mat-icon>
      </button>
    </div>

  </form>
</mat-grid-list>
